import { useSnackStore } from '@/stores/snack.store'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export const useShareLink = (link: string) => {
  const { t } = useI18n()
  const snackStore = useSnackStore()

  const copyToClipboard = () => {
    navigator.clipboard.writeText(link)
    snackStore.showInfo(t('survey.linkCopied'))
  }

  const hasWebshare = computed(() => navigator.share != undefined)

  const shareLink = () => {
    navigator
      .share({
        title: t('app.name'),
        url: link,
      })
      .catch(console.error)
  }

  return { shareLink, copyToClipboard, hasWebshare }
}
